const CMS_PATH_PROD = "https://cms.cld.eu";
const CMS_PATH_LOCAL_DEV = "http://localhost:1337";

export const useCMSURLs = Object.freeze({
  production: {
    PATH: CMS_PATH_PROD,
    PUBLIC_API_TOKEN:
      "35e754d5e62df2cdd2ad9d44a5f71fd06d6bd96f962d49209ecbf659e6a6039384b7705608667cc2a6a1ba69a8a9d78471f78559a4a1de800b3b74051641448fb3ca2600a6778a2a261ff33bc47b8095479bbad0fd94769991d060b48d50c59b36ae500c35a4e5efd24715dcbd803e83915177b48de8e0328ae95fa21aef9f69",
    HOME_PAGE: `${CMS_PATH_PROD}/api/nuxt-home`,
    DOCUMENTS:`${CMS_PATH_PROD}/api/doc`,
  },
  development: {
    PATH: CMS_PATH_LOCAL_DEV,
    PUBLIC_API_TOKEN:
      "35e754d5e62df2cdd2ad9d44a5f71fd06d6bd96f962d49209ecbf659e6a6039384b7705608667cc2a6a1ba69a8a9d78471f78559a4a1de800b3b74051641448fb3ca2600a6778a2a261ff33bc47b8095479bbad0fd94769991d060b48d50c59b36ae500c35a4e5efd24715dcbd803e83915177b48de8e0328ae95fa21aef9f69",
    HOME_PAGE: `${CMS_PATH_PROD}/api/nuxt-home`,
    DOCUMENTS:`${CMS_PATH_PROD}/api/doc`,

  },
});
